import type {RequestMiddlewareFn} from 'go/src/atlas/edison_service_worker/service_worker/lib/service_worker_middleware/types';

// Modifies navigation request to add a header indicating that the service worker is active
export function swActiveMiddleware(scope: ServiceWorkerGlobalScope): RequestMiddlewareFn {
  return async (request, next) => {
    const url = new URL(request.url);
    if (url.origin === scope.location.origin && request.mode === 'navigate') {
      const modifiedRequest = new Request(request, {
        headers: {
          ...request.headers,
          'X-Edison-Service-Worker-Active': 'true',
        },
      });
      await next(modifiedRequest);
    } else {
      await next();
    }
  };
}
